import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: 10px;
    width: max-content;
    text-decoration: none;
    padding: 40px 30px 15px;
    & span {
        color: var(--purple-2);
        font-weight: 600;
        font-size: 14px;
    }
    & svg {
        height: 18px;
    }
    & span, & svg {
        transition: 0.3s;
    }
    &:hover {
        & span, & svg {
            color: var(--purple-3);            
            fill: var(--purple-3);            
        }
    }
`;